export const PRORATIONSETTING = {
    Unset: 0,
    AlwaysPush: 10, // 0x0000000A
    NeverPush: 20, // 0x00000014
    CustomPush: 30, // 0x0000001E
}
